import { countries, isCountryISO } from '@/constants/countries';
import { isCurrencyISO } from '@/constants/currencies';
import type { CurrencyISO } from '@/constants/currencies';

export const getCurrencyISO = (countryIso: string): CurrencyISO | null => {
  const formattedCountryIso = countryIso.toLowerCase();
  if (isCountryISO(formattedCountryIso)) {
    const currencyISO = countries[formattedCountryIso]?.currencyISO;
    return isCurrencyISO(currencyISO) ? currencyISO : null;
  }
  return null;
};
